import { ColumnsType } from '@agro-club/agroclub-shared'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { TableTextLink } from 'views/ui/TableTextLink/TableTextLink'
import { generatePath } from 'react-router-dom'
import { CarrierDocsInfo } from 'views/pages/LogisticsKR/types'
import { DocCell } from './DocCell'
import CarriersKRRoutes from 'views/pages/LogisticsKR/CarriersKR/routes'
import { UploadDocBtn } from './UploadDocBtn'

export const useColumns = (refetch: () => void): ColumnsType<CarrierDocsInfo> => {
  const { t } = useTranslation('logisticsKR')

  return useMemo(
    () => [
      {
        title: t('carrier'),
        autoWidth: 400,
        dataIndex: 'carrier.id',
        render: (id, row) => (
          <TableTextLink id="carrierLink" to={generatePath(CarriersKRRoutes.Details, { id: row.carrier.id })}>
            {row.carrier.name}
          </TableTextLink>
        ),
      },
      {
        title: t('missingDocs.object'),
        width: 400,
        dataIndex: 'deal_id',
        render: (deal_id, row) => <DocCell docsInfo={row} />,
      },
      {
        title: t('missingDocs.missingDocs'),
        width: 400,
        dataIndex: 'missing_document_types',
        render: (missing_document_types) => missing_document_types.map((type) => <div key={type}>{type}</div>),
      },
      {
        title: t('missingDocs.logistician'),
        width: 200,
        dataIndex: 'logistician',
        render: (logistician) => logistician?.full_name,
      },
      {
        title: '',
        width: 120,
        dataIndex: 'carrier',
        render: (carrier, row) => <UploadDocBtn docsInfo={row} refetch={refetch} />,
      },
    ],
    [refetch, t],
  )
}
